import { render, staticRenderFns } from "./xieyiCont.vue?vue&type=template&id=4016033d&scoped=true"
import script from "./xieyiCont.vue?vue&type=script&lang=js"
export * from "./xieyiCont.vue?vue&type=script&lang=js"
import style0 from "./xieyiCont.vue?vue&type=style&index=0&id=4016033d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4016033d",
  null
  
)

export default component.exports